module.exports = __webpack_public_path__ + "static/media/APR.c7b5cff2.png";